<div class="container" id="rewards">
  @if(contentRewards?.rewardsImage){
    <div class="row">
        <img class="calculatorContainer rewardsImg col-xs-12" [ngSrc]="imagePrefix + contentRewards?.rewardsImage" 
        [alt]="contentRewards?.adaText || ''"
        width="100"
        height="100">
    </div>
  }
@else {
  <div class="row">
    <div class="col-xs-12 contentContainer paddingBottom-0">
        <h2>{{contentRewards?.header}}</h2>
        <p>{{contentRewards?.subHeader}}
            <a (click)= "scrollToElement('terms-costco')" title="Reference to number 1" style="color:#000000">
                <sup>1</sup>
            </a>
        </p>
        <p id="calculator-description-grandTotal" class="h4-headline">{{contentRewards?.description}}</p>
        <p class="calculator-last-year">
            <span>{{contentRewards?.lastYear}}</span>
          </p>
    </div>
    </div>
  <!-- Calculator -->
  <div class="calculatorContainer col-xs-12" *ngFor="let slider of contentRewards?.sliderContent; let i = index" [style]="(0 == i) ? 'border:none' : ''">
    <div class="row wrap-calculator-feature" >
        <div class="col-md-3 col-lg-3">
            <p class="calculator-multiplier value-prop-4">
                <span class="percentage_value" [innerHTML]="slider.percent"></span> 
                <span class="medText_description">
                    <strong>{{slider.desc}}</strong>
                </span></p>
        </div>
        <div class="col-md-7 col-lg-7 slider-container">
            <div class="slider">
                <p class="callabup">{{slider.sliderUpLable}}</p>
                <p class="callabdown" >{{slider.sliderDownLable}}</p>
                <citi-value-slider
                    [(value)]="slider.value"
                    idStr={{slider.id}}
                    range="max"
                    min={{slider.min}}
                    max={{slider.max}}
                    [step]="+slider.step"
                    showLabels="true"
                    handleLabel="minimum value of $0 and a maximum value of $3000 a month"
                    minHandleLabel="min"
                    maxHandleLabel="max"
                    unitOfAmount="dollars"
                    showHashMarks="false"
                    (valueChange)="sliderCalculation($event,i+1,slider.rate)"
                ></citi-value-slider>
                <span class="ui-slider-tip ui-slider-tip{{i+1}} visible">
                    <input role="presentation" tabindex="-1" aria-label="Cash Spend" type="text" readonly="" value="${{slider.value}}"/><span><br role="presentation">a Month</span>
                </span>
            </div>
        </div>
        <div class="col-md-2 col-lg-2">
            <p class="calculator-results">
                <input role="presentation" tabindex="-1" aria-label="Annual Cash Back" type="text" id="result{{i+1}}" value=""  readonly="">
                <label>Annual Cash Back</label>
            </p>
        </div>
    </div>
    <div class="row">
        <strong style="display: block;" class="col-12 smallText_description" [innerHTML]="slider.innerDesc"></strong>
    </div>
  </div>
 
  <!-- Total -->
  <div class="calculator-total col-xs-12">
    <div class="wrap-calculator-total">
        <div class="row">
            <div class="col-lg-10 totalLabel">
                <h3 class="mt-3">Total Annual Cash Back</h3>
            </div>
            <div class="col-lg-2">
                <p class="calculator-results">
                    <input role="presentation" tabindex="-1"  aria-label="Total Annual Cash Back" type="text" id="total-result" value="${{totalResult}}" readonly="">
                </p>
            </div>
        </div>
    </div><!-- close #wrap-calculator-total -->
    <p id="grandTotal-disclaimer-1" class="disclaimer">{{contentRewards?.disclaimer1}}</p>
    <br role="presentation">
    <p id="grandTotal-disclaimer-2" class="disclaimer" [innerHTML] = "contentRewards?.disclaimer2"></p>
</div>
}
</div>